module.exports = __webpack_public_path__ + "img/captcha.bce9ed77.svg";